/**
 * NOVAWEAR theme.js — minimal global: drawers, mobile menu, carousel controls
 */
(function () {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function trapFocus(container) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function initMobileMenu() {
    var root = qs('[data-nw-mobile-nav]');
    if (!root) return;
    var openBtn = qs('[data-nw-nav-open]', root);
    var closeBtn = qs('[data-nw-nav-close]', root);
    var drawer = qs('[data-nw-mobile-drawer]', root);
    if (!drawer) return;

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        var f = qs('a,button', drawer);
        if (f) f.focus();
        trapFocus(drawer);
      }
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        setOpen(true);
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setOpen(false);
      });
    }
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer.querySelector('.nw-mobile-drawer__backdrop')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });
  }

  function initCarousels() {
    qsa('[data-nw-carousel]').forEach(function (root) {
      var track = qs('[data-nw-carousel-track]', root);
      var prev = qs('[data-nw-carousel-prev]', root);
      var next = qs('[data-nw-carousel-next]', root);
      if (!track) return;
      var amount = function () {
        return Math.max(240, track.clientWidth * 0.85);
      };
      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -amount(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: amount(), behavior: 'smooth' });
        });
      }
    });
  }

  function initGenericDrawers() {
    qsa('[data-nw-drawer]').forEach(function (drawer) {
      var id = drawer.getAttribute('id');
      if (!id) return;
      qsa('[data-nw-drawer-open="' + id + '"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
        });
      });
      qsa('[data-nw-drawer-close="' + id + '"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
        });
      });
    });
  }

  function initSearchDrawer() {
    var drawer = qs('[data-nw-search-drawer]');
    var openBtns = qsa('[data-nw-search-open]');
    var closeBtns = qsa('[data-nw-search-close]');
    var backdrop = drawer ? qs('[data-nw-search-backdrop]', drawer) : null;
    if (!drawer || !openBtns.length) return;

    function set(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openBtns.forEach(function (b) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        var inp = qs('input[type="search"],input[type="text"]', drawer);
        if (inp) setTimeout(function () {
          inp.focus();
        }, 50);
        trapFocus(drawer);
      }
    }

    openBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        set(true);
      });
    });
    closeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        set(false);
      });
    });
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        set(false);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) set(false);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initSearchDrawer();
    initCarousels();
    initGenericDrawers();
  });
})();
